module.exports = __webpack_public_path__ + "img/pro-erp3.602e9325.jpg";